import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, UserCheck, Radio, Calendar, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { AdminLayout } from "@/components/AdminLayout";
import { useAuth } from "@/context/AuthContext";

export default function AdminDashboard() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const load = () => api.get("/admin/stats").then((r) => setStats(r.data));
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, []);

  const cards = [
    { key: "employees", label: "Total Employees", icon: Users, accent: "#0090A8" },
    { key: "active_employees", label: "Active", icon: UserCheck, accent: "#12805C" },
    { key: "live_webinars", label: "Live Now", icon: Radio, accent: "#D92D20" },
    { key: "upcoming_webinars", label: "Upcoming", icon: Calendar, accent: "#0090A8" },
  ];

  return (
    <AdminLayout>
      <div className="p-8 max-w-5xl">
        <div className="overline mb-2">Overview</div>
        <h1 className="font-display font-black text-4xl tracking-tight mb-1">Dashboard</h1>
        <p className="text-gray-500 mb-10">Welcome back, {user?.name}.</p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.key} data-testid={`stat-${c.key}`} className="bg-[#F5F5F5] border border-[#E4E4E7] rounded-sm p-5">
                <Icon size={22} style={{ color: c.accent }} />
                <div className="font-display font-black text-4xl mt-4 tracking-tight" style={{ color: c.key === "live_webinars" && stats?.[c.key] > 0 ? "#D92D20" : "#0A0A0A" }}>
                  {stats ? stats[c.key] : "—"}
                </div>
                <div className="overline mt-1">{c.label}</div>
              </div>
            );
          })}
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <button onClick={() => nav("/admin/webinars/new")} data-testid="quick-create-webinar"
            className="group bg-[#F5F5F5] border border-[#E4E4E7] hover:border-[#0090A8] rounded-sm p-6 text-left transition-colors">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-display font-bold text-lg">Schedule a Webinar</h3>
                <p className="text-gray-500 text-sm mt-1">Create and auto-provision live stream settings.</p>
              </div>
              <ArrowRight className="text-gray-600 group-hover:text-[#0090A8] transition-colors" />
            </div>
          </button>
          <button onClick={() => nav("/admin/employees")} data-testid="quick-manage-employees"
            className="group bg-[#F5F5F5] border border-[#E4E4E7] hover:border-[#0090A8] rounded-sm p-6 text-left transition-colors">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-display font-bold text-lg">Manage Employees</h3>
                <p className="text-gray-500 text-sm mt-1">Import via Excel, add, or reset passwords.</p>
              </div>
              <ArrowRight className="text-gray-600 group-hover:text-[#0090A8] transition-colors" />
            </div>
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
